import { TierFilterSettings } from './tier-filter-settings';

export class TierFilterDialogResult {
    filterSettings: TierFilterSettings;
    saveToSpeicher: boolean;

    constructor(filterSettings: TierFilterSettings, saveToSpeicher = false) {
        this.filterSettings = filterSettings;
        this.saveToSpeicher = saveToSpeicher;
    }

    static unwrap(value: TierFilterDialogResult | TierFilterSettings | null | undefined): TierFilterSettings | null {
        if (!value) {
            return null;
        }
        if (value instanceof TierFilterDialogResult) {
            return value.filterSettings;
        }
        if (typeof value === 'object' && 'filterSettings' in value) {
            return (value as TierFilterDialogResult).filterSettings;
        }
        return value as TierFilterSettings;
    }
}
